import { render, staticRenderFns } from "./SelectFeatures.vue?vue&type=template&id=1da0d4a8&"
import script from "./SelectFeatures.vue?vue&type=script&lang=js&"
export * from "./SelectFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports